export default function is_function(obj) {
    return typeof obj === "function"
}
